import { ContractDocumentContentResponseInterface } from '../../../../interfaces/response/contracts/contract-document-content-response/contract-document-content-response-interface';

export class ContractDocumentContentResponseModel implements ContractDocumentContentResponseInterface {
  content: string = '';
  mimeType: string = '';

  constructor(init?: Partial<ContractDocumentContentResponseModel>) {
    Object.assign(this, init);
  }
}
